import React from "react";
import { useTranslation } from "react-i18next";

import TableCell from "components/Tables/TableCell";

export default function CargoInfoTableData({ content = {} }) {
    const { t } = useTranslation();

    // Строка 1: Вес, наименование
    const titleParts = [];
    if (content.weight) {
        titleParts.push(`${content.weight} ${t("units.tons")}`);
    }
    const cargoName = content.designation || content.cargo_designations_additional;
    if (cargoName) {
        titleParts.push(cargoName);
    }
    const combinedTitle = titleParts.join(", ");

    // Строка 2: расстояние, ADR, объем
    const descriptionParts = [];
    if (content.route_distance_meters) {
        const distanceKm = Math.round(content.route_distance_meters / 1000);
        descriptionParts.push(`${distanceKm} ${t("units.km")}`);
    }
    const hasAdr = content.adr_captions || content.adr_items;
    if (hasAdr) {
        descriptionParts.push(t("forms.adr"));
    }
    if (content.volume) {
        descriptionParts.push(`${content.volume} ${t("units.cubage")}³`);
    }
    // Габариты (ДxШxВ)
    const length = parseFloat(content.length);
    const width = parseFloat(content.width);
    const height = parseFloat(content.height);
    const sizeParts = [];
    if (length > 0) sizeParts.push(length);
    if (width > 0) sizeParts.push(width);
    if (height > 0) sizeParts.push(height);
    if (sizeParts.length > 0) {
        descriptionParts.push(`${sizeParts.join("x")} ${t("units.m")}`);
    }
    const description = descriptionParts.join(", ");

    // Строка 3: Примечание (notes)
    const description2 = content.notes ? `Прим. ${content.notes}` : "";

    return <TableCell title={combinedTitle} description={description} description2={description2} />;
}
